import { render, staticRenderFns } from "./todopromo.vue?vue&type=template&id=356ce244&scoped=true&"
import script from "./todopromo.vue?vue&type=script&lang=js&"
export * from "./todopromo.vue?vue&type=script&lang=js&"
import style0 from "./todopromo.vue?vue&type=style&index=0&id=356ce244&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ce244",
  null
  
)

export default component.exports